import { render, staticRenderFns } from "./AdminNotifications.vue?vue&type=template&id=6a02b072&scoped=true"
import script from "./AdminNotifications.vue?vue&type=script&lang=js"
export * from "./AdminNotifications.vue?vue&type=script&lang=js"
import style0 from "./AdminNotifications.vue?vue&type=style&index=0&id=6a02b072&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a02b072",
  null
  
)

export default component.exports